import firebase from 'firebase/app';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCQqEx83VQQs2p3Cdjph2o_b5_Z6yv616c',
  authDomain: 'beverix.firebaseapp.com',
  databaseURL: 'https://beverix.firebaseio.com',
  projectId: 'beverix',
  storageBucket: 'beverix.appspot.com',
  messagingSenderId: '682224474661',
  appId: '1:682224474661:web:011b18397918dcfc6bfdcc',
  measurementId: 'G-PV596FT0B2',
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export { storage, firebase as default };
